const KIND_STYLES = {
    po: {
        inactive: 'bg-blue-50 hover:bg-blue-100 text-blue-800 border-blue-200',
        active: 'bg-blue-100 text-blue-900 border-blue-300 border-b-2 border-b-blue-600',
        dot: 'bg-blue-500',
    },
    invoice: {
        inactive: 'bg-green-50 hover:bg-green-100 text-green-800 border-green-200',
        active: 'bg-green-100 text-green-900 border-green-300 border-b-2 border-b-green-600',
        dot: 'bg-green-500',
    },
    order: {
        inactive: 'bg-teal-50 hover:bg-teal-100 text-teal-800 border-teal-200',
        active: 'bg-teal-100 text-teal-900 border-teal-300 border-b-2 border-b-teal-600',
        dot: 'bg-teal-500',
    },
    picking: {
        inactive: 'bg-orange-50 hover:bg-orange-100 text-orange-800 border-orange-200',
        active: 'bg-orange-100 text-orange-900 border-orange-300 border-b-2 border-b-orange-600',
        dot: 'bg-orange-500',
    },
    packing: {
        inactive: 'bg-amber-50 hover:bg-amber-100 text-amber-800 border-amber-200',
        active: 'bg-amber-100 text-amber-900 border-amber-300 border-b-2 border-b-amber-600',
        dot: 'bg-amber-500',
    },
    product: {
        inactive: 'bg-purple-50 hover:bg-purple-100 text-purple-800 border-purple-200',
        active: 'bg-purple-100 text-purple-900 border-purple-300 border-b-2 border-b-purple-600',
        dot: 'bg-purple-500',
    },
    category: {
        inactive: 'bg-indigo-50 hover:bg-indigo-100 text-indigo-800 border-indigo-200',
        active: 'bg-indigo-100 text-indigo-900 border-indigo-300 border-b-2 border-b-indigo-600',
        dot: 'bg-indigo-500',
    },
    brand: {
        inactive: 'bg-pink-50 hover:bg-pink-100 text-pink-800 border-pink-200',
        active: 'bg-pink-100 text-pink-900 border-pink-300 border-b-2 border-b-pink-600',
        dot: 'bg-pink-500',
    },
    supplier: {
        inactive: 'bg-slate-100 hover:bg-slate-200 text-slate-800 border-slate-300',
        active: 'bg-slate-200 text-slate-900 border-slate-400 border-b-2 border-b-slate-600',
        dot: 'bg-slate-500',
    },
    customer: {
        inactive: 'bg-rose-50 hover:bg-rose-100 text-rose-800 border-rose-200',
        active: 'bg-rose-100 text-rose-900 border-rose-300 border-b-2 border-b-rose-600',
        dot: 'bg-rose-500',
    },
    receipt: {
        inactive: 'bg-cyan-50 hover:bg-cyan-100 text-cyan-800 border-cyan-200',
        active: 'bg-cyan-100 text-cyan-900 border-cyan-300 border-b-2 border-b-cyan-600',
        dot: 'bg-cyan-500',
    },
    planner: {
        inactive: 'bg-yellow-50 hover:bg-yellow-100 text-yellow-800 border-yellow-200',
        active: 'bg-yellow-100 text-yellow-900 border-yellow-300 border-b-2 border-b-yellow-600',
        dot: 'bg-yellow-500',
    },
    'production-release': {
        inactive: 'bg-lime-50 hover:bg-lime-100 text-lime-800 border-lime-200',
        active: 'bg-lime-100 text-lime-900 border-lime-300 border-b-2 border-b-lime-600',
        dot: 'bg-lime-500',
    },
    report: {
        inactive: 'bg-violet-50 hover:bg-violet-100 text-violet-800 border-violet-200',
        active: 'bg-violet-100 text-violet-900 border-violet-300 border-b-2 border-b-violet-600',
        dot: 'bg-violet-500',
    },
};

const DEFAULT_STYLE = {
    inactive: 'bg-gray-50 hover:bg-gray-200 text-gray-600 border-gray-200',
    active: 'bg-white text-gray-900 border-gray-300 border-b-2 border-b-blue-500',
    dot: 'bg-gray-400',
};

export const getTabStyle = (kind) => KIND_STYLES[kind] || DEFAULT_STYLE;
